Ext.define('Ext.ux.form.field.TextExd', {
    extend: 'Ext.form.field.Text',
    alias: 'widget.textfieldexd',
    getValue2: function () {
        return this.getValue() === null || this.getValue() === "" || (this.getValue() != null && this.getValue().trim && this.getValue().trim() === "") ? null : (this.getValue().trim ? this.getValue().trim() : this.getValue());
    },
    setValue2: function (v) {
        this.setValue(v === null ? "" : v);
    }
});
